import { AxiosRequestConfig } from "axios";
import { apis } from "service";
// Same signature, answered by the new backend. See legacy-lookup-api.ts.
import {
  searchContact2,
  SearchContactReqType,
} from "service/moneeflo/legacy-lookup-api";

const URLS = {
  getEntityLeads: "https://xxl6-bbr3-kxzs.m2.xano.io/api:FiAQK2sE/get_entity_leads_v3"
}

// This interface should ideally be defined in a shared types file
export interface LeadContactsProps {
  id: string;
  name: string;
  mobile: string;
  contactStatus: string;
  isCustomer: boolean;
  link_customer: string | null;
}

export interface PageDetails {
  pageTotal?: number;
  curPage?: number;
  itemsReceived?: number;
  itemsTotal?: number;
  nextPage?: number;
  offset?: number;
  perPage?: number;
  prevPage?: number;
}

interface FetchedContactsResponse {
  contacts: LeadContactsProps[];
  pageDetails: PageDetails;
}

// This function is now solely responsible for fetching and transforming the data.
export const fetchContactsAPI = async (
  searchQuery: string,
  page: number,
  per_page: number
): Promise<FetchedContactsResponse> => {

  const payload: AxiosRequestConfig<SearchContactReqType> = {
    params: {
      type: "retail",
      searchQuery: searchQuery,
      paging: {
        page: page,
        per_page: per_page,
        offset: 0,
      },
    },
  };

  const response = (await searchContact2(payload)) as any; // Cast as any to match original logic

  if (!response?.data?.items?.length) {
    return { contacts: [], pageDetails: {} };
  }

  // Data transformation logic is kept intact but moved here
  const transformedContacts: LeadContactsProps[] = response.data.items.map(
    (item: any) => {
      const hasCustomerTypes = Array.isArray(item?.customer_types);
      const contactStatus = hasCustomerTypes
        ? item.customer_types.includes("Customer")
          ? "customer"
          : "contact"
        : item?.linked_customer_id && item?.customer
        ? "customer"
        : "contact";

      const link_customers = hasCustomerTypes
        ? item?.id
        : item?.linked_customer_id;

      return {
        id: item?.id,
        name: item?.contactName || item?.full_name || "",
        mobile: item?.contactNumber || item?.phone_number || "",
        contactStatus,
        isCustomer: hasCustomerTypes
          ? item.customer_types.includes("Customer")
          : item?.customer,
        link_customer: link_customers,
      };
    }
  );

  const pageDetails: PageDetails = {
    pageTotal: response?.data?.pageTotal,
    curPage: response?.data?.curPage,
    itemsReceived: response?.data?.itemsReceived,
    itemsTotal: response?.data?.itemsTotal,
    nextPage: response?.data?.nextPage,
    offset: response?.data?.offset,
    perPage: response?.data?.perPage,
    prevPage: response?.data?.prevPage,
  };

  return { contacts: transformedContacts, pageDetails };
};

export const getEnityLeads = async ({branch}: {branch: number | string}) => {
  const payload: AxiosRequestConfig<{branch: number | string}> = {   
    params:{
      branch
    } 
  };
  const response = await apis.get(URLS.getEntityLeads, payload)
  return response
}